import { render, staticRenderFns } from "./EmployeeResource.vue?vue&type=template&id=3589bf82&"
import script from "./EmployeeResource.vue?vue&type=script&lang=js&"
export * from "./EmployeeResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports